$(document).ready(function () {
    if (!$('#terms-container').length) {
        return;
    }
    $('.accordion-single-wrapper').on('click', function () {
        $(this).find('.accordion-content-wrapper').toggleClass('show');
    });
});